import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import DIWPersonalise from '@/components/diw.personalisation.element';
import DIWBasketButton from '@/components/diw.basket.button';

export default class DIWPersonaliseContainer extends TKCustomElementFactory {
    private text: string[] = ['', '', ''];
    basketButton?: DIWBasketButton;
    personaliseElements: NodeListOf<DIWPersonalise>;
    salDocAttr?: string;

    constructor() {
        super();

        this.basketButton = this.querySelector('[data-tk-basket-button]') || undefined;
        this.personaliseElements = this.querySelectorAll('[data-tk-personalise]');
        this.salDocAttr = this.getAttribute('data-tk-saldoc-attr') || undefined;
    }

    connectedCallback(): void {
        if (this.personaliseElements.length === 0) return;
        if (!this.basketButton) throw new Error('DIWPersonalisationContainer: No Basketbutton found');
        if (!this.salDocAttr || !this.salDocAttr.toLowerCase().startsWith('saldocitem'))
            throw new Error('DIWPersonalisationElement: missing or wrong SalDocItem Attribute');

        this.checkRequired();
    }

    updateBasketButton(element: DIWPersonalise, value: string): void {
        const fraction = [...this.personaliseElements].indexOf(element);
        this.text[fraction] = value;

        this.basketButton!.setAttribute(`data-tk-${this.salDocAttr!}`, this.text.join('\n'));

        this.checkRequired();
    }

    checkRequired() {
        const check = !![...this.personaliseElements].filter((e) => e.isRequired && e.textarea?.value != '').length;

        this.basketButton!.button!.disabled = !check;
    }
}
